import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PostoService {
 	private data = null;
	private url = environment.serviceApi;
 	constructor(public http: Http) { }

  	getPostos(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/posto' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getposto(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/posto/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getPostoPorCliente(clienteId) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/posto/buscaPostoPorCliente/' + clienteId)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	criaPosto(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/posto', {
				posto_nome: data.posto_nome,
				posto_cnpj: data.posto_cnpj,
				posto_endereco: data.posto_endereco,
				posto_endereco_numero: data.posto_endereco_numero,
				posto_cep: data.posto_cep,
				municipio_id: data.municipio_id,
				bairro_id: data.bairro_id,
				uf_id: data.uf_id
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaPosto(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/posto/' + data.posto_id, {
				posto_nome: data.posto_nome,
				posto_cnpj: data.posto_cnpj,
				posto_endereco: data.posto_endereco,
				posto_endereco_numero: data.posto_endereco_numero,
				posto_cep: data.posto_cep,
				municipio_id: data.municipio_id,
				bairro_id: data.bairro_id,
				uf_id: data.uf_id
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaPosto(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/posto/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
